import { Link, useLocation } from "wouter";
import { Menu, X } from "lucide-react";

import logo from "../assets/logo.png";
import { useState } from "react";

function NavBar() {
  const [open, setOpen] = useState(false);
  const [location] = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "About Us", path: "/about" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <nav className="fixed top-0 z-50 w-full bg-[#2b2f36]">
      <div className="mx-auto max-w-7xl px-4">
        <div className="flex h-20 items-center justify-between">

          {/* Logo */}
          <Link href="/">
            <img
              src={logo}
              alt="Xstream Minds"
              className="h-16 cursor-pointer"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link key={item.path} href={item.path}>
                <a
                  className={`text-sm font-medium transition-colors ${
                    location === item.path
                      ? "text-orange-500"
                      : "text-white hover:text-orange-400"
                  }`}
                >
                  {item.label}
                </a>
              </Link>
            ))}

            <Link href="/contact">
              <a className="rounded-md bg-orange-500 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-600">
                Get in Touch
              </a>
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-white"
          >
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {open && (
          <div className="md:hidden pb-6">
            <div className="flex flex-col gap-4">
              {navItems.map((item) => (
                <Link key={item.path} href={item.path}>
                  <a
                    onClick={() => setOpen(false)}
                    className={`text-sm font-medium ${
                      location === item.path
                        ? "text-orange-500"
                        : "text-white"
                    }`}
                  >
                    {item.label}
                  </a>
                </Link>
              ))}

              <Link href="/contact">
                <a
                  onClick={() => setOpen(false)}
                  className="w-fit rounded-md bg-orange-500 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-600"
                >
                  Get in Touch
                </a>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default NavBar;
